// // import { TITLE } from "@/constants";
// // src/app/components/WhyChooseUs.js
// const WhyChooseUs = () => {
//   const features = [
//     {
//       title: "Fast and Easy Process",
//       desc: "Our simple online application ensures quick approvals and smooth loan processing. Get financial support when you need it—without the hassle.",
//       icon: "⚡",
//     },
//     {
//       title: "100% Digital Experience",
//       desc: "From application to disbursal, everything is online. No paperwork, no in-person visits—just fast, secure, and convenient service.",
//       icon: "💻",
//     },
//     {
//       title: "Quick Disbursal",
//       desc: "We understand the urgency. Once approved, your loan amount is credited to your account without unnecessary delays.",
//       icon: "🏦",
//     },
//     {
//       title: "Tailored for Salaried Employees",
//       desc: "Designed exclusively for salaried individuals to meet short-term financial needs quickly and efficiently.",
//       icon: "👔",
//     },
//     {
//       title: "Transparent & Secure",
//       desc: "No hidden fees or surprises. Clear terms, secure processing, and complete peace of mind.",
//       icon: "🔒",
//     },
//     {
//       title: "Trusted by Thousands",
//       desc: "Join thousands of satisfied salaried professionals who rely on us for quick, reliable, and transparent financial solutions.",
//       icon: "🌟",
//     },
//   ];

//   return (
//     <section className="bg-white py-16 px-6">
//       <div className="max-w-7xl mx-auto text-center">
//         <h2 className="text-3xl md:text-4xl font-bold text-[#1D3557] mb-10">
//           Why Choose <span className="text-[#4FA0FF]">Kubermax?</span>
//         </h2>
//         <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
//           {features.map((feature, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-xl p-6 border border-[#E5E5E5] hover:border-[#4FA0FF] hover:shadow-lg transition-all duration-300"
//             >
//               <div className="text-4xl mb-4">{feature.icon}</div>
//               <h3 className="text-xl font-semibold text-[#1D3557] mb-2">
//                 {feature.title}
//               </h3>
//               <p className="text-[#1D3557]/70">{feature.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChooseUs;

// const WhyChooseUs = () => {
//   const features = [
//     {
//       title: "Fast and Easy Process",
//       desc: "Quick approvals with a simple online application. No long waits—just instant financial support.",
//       icon: "⚡",
//     },
//     {
//       title: "100% Digital Experience",
//       desc: "From application to disbursal—everything is online, secure, and paperless.",
//       icon: "💻",
//     },
//     {
//       title: "Quick Disbursal",
//       desc: "Once approved, your loan amount is credited to your bank account faster than ever.",
//       icon: "🏦",
//     },
//     {
//       title: "Transparent & Secure",
//       desc: "No hidden charges. Clear, honest, and fully secure loan processing.",
//       icon: "🔒",
//     },
//   ];

//   return (
//     <section className="relative py-16 px-6 overflow-hidden">
//       {/* Background Gradient */}
//       <div className="absolute inset-0 bg-gradient-to-r from-[#2563EB]/10 to-[#E5E7EB]/40"></div>

//       {/* Glow Blobs */}
//       <div className="absolute top-20 left-10 w-56 h-56 bg-[#2563EB]/20 blur-[110px] rounded-full"></div>
//       <div className="absolute bottom-10 right-10 w-56 h-56 bg-[#4FA0FF]/20 blur-[130px] rounded-full"></div>

//       <div className="max-w-7xl mx-auto relative z-10 text-center mb-14">
//         <h2 className="text-3xl md:text-4xl font-extrabold text-[#1D3557]">
//           Why Choose <span className="text-[#2563EB]">Kubermax?</span>
//         </h2>
//       </div>

//       {/* Cards Layout 2 + 2 */}
//       <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto relative z-10">
//         {features.map((feature, index) => (
//           <div
//             key={index}
//             className="
//               relative p-6 rounded-xl backdrop-blur-lg shadow-lg
//               border border-white/40 overflow-hidden
//               hover:shadow-2xl transition-all duration-500
//             "
//           >

//             {/* 🔵 Animated Card Gradient Background */}
//             <div className="
//               absolute inset-0
//               bg-gradient-to-br from-[#2563EB]/30 via-[#4FA0FF]/20 to-white/20
//               animate-gradientMove
//             "></div>

//             {/* 🫧 Bubble Glow Circles */}
//             <div className="absolute -top-6 -right-6 w-20 h-20 bg-white/40 blur-2xl rounded-full"></div>
//             <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#2563EB]/20 blur-3xl rounded-full"></div>

//             <div className="relative z-10 flex flex-col items-center">
//               <div className="text-5xl mb-4 animate-bounce">
//                 {feature.icon}
//               </div>

//               <h3 className="text-xl font-semibold text-[#1D3557] mb-2">
//                 {feature.title}
//               </h3>

//               <p className="text-[#1D3557]/70 leading-relaxed text-sm">
//                 {feature.desc}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Animation for gradient */}
//       <style>
//         {`
//           @keyframes gradientMove {
//             0% { background-position: 0% 0%; }
//             50% { background-position: 100% 100%; }
//             100% { background-position: 0% 0%; }
//           }

//           .animate-gradientMove {
//             background-size: 200% 200%;
//             animation: gradientMove 6s ease infinite;
//           }
//         `}
//       </style>
//     </section>
//   );
// };

// export default WhyChooseUs;
// import React from "react";
// import { motion } from "framer-motion";

// const WhyChooseUs = () => {
//   const features = [
//     {
//       title: "Fast and Easy Process",
//       desc: "Quick approvals with a simple online application. No long waits—just instant financial support.",
//       icon: "⚡",
//     },
//     {
//       title: "100% Digital Experience",
//       desc: "From application to disbursal—everything is online, secure, and paperless.",
//       icon: "💻",
//     },
//     {
//       title: "Quick Disbursal",
//       desc: "Once approved, your loan amount is credited to your bank account faster than ever.",
//       icon: "🏦",
//     },
//     {
//       title: "Transparent & Secure",
//       desc: "No hidden charges. Clear, honest, and fully secure loan processing.",
//       icon: "🔒",
//     },
//   ];

//   return (
//     <section className="relative py-20 bg-[#0B1120] text-white overflow-hidden">
//       <div className="max-w-7xl mx-auto px-6 relative z-10">
//         {/* Heading */}
//         <h2 className="text-3xl md:text-4xl font-extrabold mb-12 text-center">
//           Why Choose <span className="text-[#4FA0FF]">Kubermax?</span>
//         </h2>

//         <div className="flex flex-col md:flex-row gap-12 items-center">
//           {/* LEFT CARDS */}
//           <div className="grid sm:grid-cols-2 gap-6 flex-1 min-h-[520px]">
//             {features.map((feature, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, x: -50 }}
//                 whileInView={{ opacity: 1, x: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.6, delay: index * 0.2 }}
//                 className="p-6 rounded-xl backdrop-blur-lg shadow-lg 
//                            border border-white/10 bg-white/5 
//                            hover:bg-white/10 cursor-pointer"
//               >
//                 <div className="text-4xl mb-3">{feature.icon}</div>
//                 <h3 className="text-lg font-semibold mb-1">{feature.title}</h3>
//                 <p className="text-white/70 text-sm leading-relaxed">
//                   {feature.desc}
//                 </p>
//               </motion.div>
//             ))}
//           </div>

//           {/* RIGHT SIDE — IMAGE OVERLAY */}
//           <div className="flex-1 flex justify-center items-stretch">
//             <div className="w-full rounded-3xl overflow-hidden shadow-xl relative min-h-[520px]">
//               {/* Image */}
//               <img
//                 src="/images/whychooseus.jpg"
//                 alt="Hero Section"
//                 className="w-full h-full object-cover rounded-3xl"
//               />

//               {/* Soft Overlay */}
//               <div className="absolute inset-0 bg-black/30 rounded-3xl"></div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Background Glow Effects */}
//       <motion.div
//         animate={{ y: [0, -20, 0] }}
//         transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//         className="absolute top-20 right-0 w-72 h-72 bg-blue-500/20 blur-[150px] rounded-full"
//       />
//       <motion.div
//         animate={{ y: [0, 20, 0] }}
//         transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
//         className="absolute bottom-20 left-0 w-72 h-72 bg-indigo-500/20 blur-[150px] rounded-full"
//       />
//     </section>
//   );
// };

// export default WhyChooseUs;
import React from "react";
import { motion } from "framer-motion";

const WhyChooseUs = () => {
  const features = [
    {
      title: "Fast and Easy Process",
      desc: "Quick approvals with a simple online application.",
      icon: "⚡",
      bg: "https://images.unsplash.com/photo-1521791136064-7986c0212926?auto=format&fit=crop&w=800&q=60",
    },
    {
      title: "100% Digital Experience",
      desc: "Everything is online, secure, and paperless.",
      icon: "💻",
      bg: "https://images.unsplash.com/photo-1555421689-3f034debb7a6?auto=format&fit=crop&w=800&q=60",
    },
    {
      title: "Quick Support Transfer",
      desc: "Support amount made available instantly.",
      icon: "🏦",
      bg: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=800&q=60",
    },
    {
      title: "Transparent & Secure",
      desc: "No hidden charges. Fully safe and encrypted.",
      icon: "🔒",
      bg: "https://images.unsplash.com/photo-1556742031-c6961e8560b0?auto=format&fit=crop&w=800&q=60",
    },
    {
      title: "Flexible Support Options",
      desc: "Choose support amounts and durations that suit your needs.",
      icon: "📊",
      bg: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=800&q=60",
    },
    {
      title: "24/7 Customer Support",
      desc: "We're always here to help — anytime, anywhere.",
      icon: "📞",
      bg: "https://images.unsplash.com/photo-1525182008055-f88b95ff7980?auto=format&fit=crop&w=800&q=60",
    },
  ];

  // duplicate for infinite loop
  const loopFeatures = [...features, ...features];

  return (
    <section className="relative py-20 bg-[#0B1120] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 relative z-10">

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-extrabold mb-12 text-center">
          Why Choose <span className="text-[#4FA0FF]">Us?</span>
        </h2>

        {/* Marquee Container */}
        <div className="overflow-hidden w-full">
          <motion.div
            className="flex gap-8"
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              duration: 22,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {loopFeatures.map((f, i) => (
              <div
                key={i}
                className="relative min-w-[280px] max-w-[280px] p-6 rounded-2xl shadow-lg bg-cover bg-center
                           hover:-translate-y-2 transition-all duration-300 cursor-default"
                style={{ backgroundImage: `url(${f.bg})` }}
              >
                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black/60 rounded-2xl"></div>

                {/* Inner Content */}
                <div className="relative z-10 text-center">
                  {/* ICON CENTER */}
                  <div className="text-4xl mb-4 bg-white/10 w-16 h-16 rounded-2xl 
                                  flex items-center justify-center mx-auto">
                    {f.icon}
                  </div>

                  <h3 className="text-lg font-semibold mb-2 text-white">
                    {f.title}
                  </h3>

                  <p className="text-gray-300 text-sm leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>

      {/* Background Glow */}
      <motion.div
        animate={{ y: [0, -20, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-20 right-0 w-72 h-72 bg-blue-500/20 blur-[150px] rounded-full"
      />

      <motion.div
        animate={{ y: [0, 20, 0] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className="absolute bottom-20 left-0 w-72 h-72 bg-indigo-500/20 blur-[150px] rounded-full"
      />
    </section>
  );
};

export default WhyChooseUs;